import axios from 'axios'
import CONFIG from '@/config/config'
const PRE_FIX = CONFIG.API_URL //+ (CONFIG.PROFILE === 'production' ? '/api':'')
import Vue from 'vue'

let checkParams = function(params) {
    let checkObj = $.extend(true,{},params)
    let checkedKeys = Object.keys(checkObj).filter(key => key !== 'page' && !checkObj[key])
    checkedKeys.forEach(function(key) {
        delete checkObj[key]
    })
    return  checkObj
}

export default {
    async getS3Html(layoutName) {
        return await axios.get('https://pub-myhana.s3-ap-southeast-1.amazonaws.com/mail-layout/' + layoutName + '/index.html');
    },
    async getLayouts(params) {
        console.log(PRE_FIX)
        return await axios.get(PRE_FIX + '/v1/ums/layout/list', {params: checkParams(params)}).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async deleteLayout(layoutId) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/layout/delete/' + layoutId).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async saveLayout(params, file) {
        Vue.prototype.$loading(true)
        let formData = new FormData();
        let requestObj = checkParams(params)
        formData.append('file', file)
        formData.append('name',requestObj.name)
        formData.append('clientCd',requestObj.clientCd)
        formData.append('lang',requestObj.lang)
        return await axios.post(PRE_FIX + '/v1/ums/layout/save', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
}
